import { render, staticRenderFns } from "./EmployeeBenefitsBrokers.vue?vue&type=template&id=deecc5b0&"
import script from "./EmployeeBenefitsBrokers.vue?vue&type=script&lang=js&"
export * from "./EmployeeBenefitsBrokers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports